module.exports = __webpack_public_path__ + "static/media/builtinv2-SCHITOV Pitanie.8de68d68.png";